import { memo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { Outlet } from 'react-router-dom';

import { Loader, Media } from '@/js/libs/ui';
import { useIdentityRoles } from '@/js/libs/use-auth';

import { AppSuspense } from 'src/components/AppSuspense';
import ReloadHeader from 'src/components/ReloadHeader';
import ScrollArrow from 'src/components/ScrollArrow';
import { TO_TOP_ARROW_OFFSET } from 'src/constants';
import { Navigation } from './Navigation';
import { Header } from './Navigation/components';
import { useNavigationContext } from './Navigation/context';
import ScrollToTop from './ScrollToTop';
import { Content, Wrapper } from './styled';

export const Layout = memo(function Layout() {
  const [t] = useTranslation(['backend', 'common']);
  const { isCollapsedNav } = useNavigationContext();
  const { ANONYMOUS } = useIdentityRoles();
  const isDesktop = useMediaQuery({ query: Media.lgMin });

  return (
    <>
      <Helmet title={t('common:GENERAL_TITLE')} />
      <Wrapper isCollapsedNav={isCollapsedNav}>
        {!ANONYMOUS && <Navigation />}
        <Content isCollapsedNav={isCollapsedNav} fullWidth={!!ANONYMOUS}>
          {!isDesktop && !ANONYMOUS && <Header />}
          <AppSuspense fallback={<Loader />}>
            <Outlet />
          </AppSuspense>
        </Content>
      </Wrapper>
      <ReloadHeader />
      <ScrollToTop />
      <ScrollArrow offset={TO_TOP_ARROW_OFFSET} />
    </>
  );
});
